module.exports = "/images/grey_IG.png?f33996bffb76a13c9ff626d0ce2639f1";